import { render, staticRenderFns } from "./birthDayList.vue?vue&type=template&id=01b00035&"
import script from "./birthDayList.vue?vue&type=script&lang=js&"
export * from "./birthDayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports